/**
 * Types relacionados à Sessão do usuário
 */

export enum SessionKeys {
  // Vendedor
  VEND_ID = 'vendId',
  VEND_CODIGO = 'vendCodigo',
  VEND_TIPO = 'vendTipo',
  VEND_NOME = 'vendNome',
  VEND_EMAIL = 'vendEmail',
  
  // Indicadores
  IND_PEDIDO = 'indPedido',
  IND_PREVISAO = 'indPrevisao',
  IND_PREVISAO_ID = 'indPrevisaoId',
  IND_PREVISAO_INI = 'indPrevisaoIni',
  IND_PREVISAO_FIM = 'indPrevisaoFim',
  IND_PREVISAO_CONFIRMA = 'indPrevisaoConfirma',
  
  // Cliente
  CLI_CODIGO = 'cliCodigo',
  CLI_NOME = 'cliNome',
  
  // Carrinho
  CARRINHO = 'carrinho',
  CARRINHO_TIPO = 'carrinhoTipo',
  
  // Navegação
  LAST_CLASSIFICACAO = 'lastClassificacao',
  LAST_PRODUTO = 'lastProduto',
}

export interface SessionData {
  // Vendedor
  vendId?: number;
  vendCodigo?: string;
  vendTipo?: string;
  vendNome?: string;
  vendEmail?: string;
  
  // Indicadores
  indPedido?: number;
  indPrevisao?: number;
  indPrevisaoId?: number;
  indPrevisaoIni?: string;
  indPrevisaoFim?: string;
  
  // Cliente
  cliCodigo?: string;
  cliNome?: string;
  
  // Carrinho
  carrinho?: string;
  carrinhoTipo?: 'previsao' | 'pedido';
  
  // Navegação
  lastClassificacao?: string;
  lastProduto?: string;
}

export interface SessionConfig {
  key: SessionKeys;
  required?: boolean;
  defaultValue?: any;
}

export type SessionStorage = 'sessionStorage' | 'localStorage';